import { render, staticRenderFns } from "./onboarding.vue?vue&type=template&id=6502871d&scoped=true"
import script from "./onboarding.vue?vue&type=script&lang=js"
export * from "./onboarding.vue?vue&type=script&lang=js"
import style0 from "./onboarding.vue?vue&type=style&index=0&id=6502871d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6502871d",
  null
  
)

export default component.exports